import { BILLING_ADDRESS_SCOPE } from '../../../../../constants/billing'
import { PhoneInstruction } from './PhoneInstruction'

export class BillingPhoneInstruction extends PhoneInstruction {
  constructor ({ waitForNoLoaders, value }) {
    super({ waitForNoLoaders, value })
    this.name = 'BillingPhone'
    this.scope = BILLING_ADDRESS_SCOPE
  }

  setDefaultValue (params) {
    this.value = params.userInformation.phone
  }
}
